<template>
    <div class="col-xs-12 col-sm-6 col-lg-4 pl-3 pr-3 h-100 diagram__col-container">
        <div class="
        d-flex
        flex-column
        justify-content-between
        diagram__col
        h-100
        pr-1
        pl-1
        pt-4
        pb-2">
            <h6 class="diagram__col-title"><strong>{{ category }}</strong></h6>
            <ul class="
            diagram__list
            d-flex
            flex-column
            justify-content-center
            pt-2"
                :style="{background: macro.color}">
                <li class="diagram__list-bracket" v-if="category === 'Inputs'"></li>
                <li v-for="(item, index) in macro.data" :key="index">
                    <button class="btn btn-sm btn-link"
                            @click="openDetailsModal(item)">
                        {{ item.name }}
                    </button>
                </li>
            </ul>
            <ul class="
            diagram__list
            d-flex
            flex-column
            justify-content-center
            pt-2"
                :style="{background: meso.color}">
                <li class="diagram__list-bracket" v-if="category === 'Inputs'"></li>
                <li v-for="(item, index) in meso.data" :key="index">
                    <button class="btn btn-sm btn-link"
                            @click="openDetailsModal(item)">
                        {{ item.name }}
                    </button>
                </li>
            </ul>
            <ul class="
            diagram__list
            d-flex
            flex-column
            justify-content-center
            pt-2"
                :style="{background: micro.color}">
                <li class="diagram__list-bracket" v-if="category === 'Inputs'"></li>
                <li>
                    <BTabs content-class="mt-3" pills align="center">
                        <BTab :title="sublevel"
                              v-for="(sublevel, index) in micro.sublevels"
                              :key="index">
                            <div v-for="(item, index) in micro.data"
                                 :key="index">
                                <button class="btn btn-sm btn-link"
                                        @click="openDetailsModal(item)"
                                        v-if="sublevel === item.sublevel">
                                    {{ item.name }}
                                </button>
                            </div>
                        </BTab>
                    </BTabs>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue';

export default {
  props: ['category', 'macro', 'meso', 'micro'],
  components: {
    BTabs,
    BTab,
  },
  methods: {
    openDetailsModal(item) {
      this.$store.commit('diagram/item', item);
      this.$store.commit('diagram/isDetailsModalOpen', true);
    },
  },
};
</script>
